export function translatable_empty(names) {
    return Object.values(names || {}).every((value) => !String(value ?? '').trim());
}

export function translatable_equal(left, right) {
    const keys = new Set([...Object.keys(left || {}), ...Object.keys(right || {})]);
    for (const key of keys) {
        if (String((left || {})[key] ?? '').trim() !== String((right || {})[key] ?? '').trim())
            return false;
    }
    return true;
}

const DISCOUNT_TYPES = ['manual_discount', 'auto_discount', 'code_discount'];

export function should_sync_first_variant_name({
    articleType,
    variantCount,
    articleName,
    variantName,
    lastAutoCopiedName,
}) {
    if (DISCOUNT_TYPES.includes(articleType))
        return false;
    if (variantCount !== 1)
        return false;
    if (translatable_empty(articleName))
        return false;
    if (translatable_equal(variantName, articleName))
        return false;
    if (translatable_empty(variantName))
        return true;
    if (lastAutoCopiedName && translatable_equal(variantName, lastAutoCopiedName))
        return true;
    return false;
}

export function name_for_new_variant({
    isFirst,
    langs,
    articleName,
    previousVariantName,
    needsCode,
    generatedCode,
}) {
    if (needsCode) {
        const name = {};
        (langs || []).forEach((lang) => {
            name[lang] = generatedCode;
        });
        return name;
    }
    if (isFirst && !translatable_empty(articleName))
        return { ...articleName };
    if (!translatable_empty(previousVariantName))
        return { ...previousVariantName };
    return {};
}
